import { useEffect } from "react";

export function useInitPaddle() {
    useEffect(() => {
        const token = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;

        if (!token) {
            console.error("❌ Missing REACT_APP_PADDLE_CLIENT_TOKEN");
            return;
        }

        function initWhenReady() {
            if (!window.Paddle || !window.Paddle.Initialize) {
                return setTimeout(initWhenReady, 50);
            }

            window.Paddle.Environment.set("sandbox"); // or production

            window.Paddle.Initialize({
                token,
            });

            window.__PADDLE_READY__ = true;
        }

        initWhenReady();
    }, []);
}